import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper/modules";
import { Link, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { likeImgState, likeState } from "../store";

function Detail({ data, handleScroll, handleLikeUp, handleLikeDown }) {
  let { id } = useParams();
  // console.log(id);
  let result = eval(id) + 1;

  const [like, setLike] = useRecoilState(likeState);
  const [likeimg, setLikeimg] = useRecoilState(likeImgState);

  return (
    <>
      <div className="fixed w-full h-full flex justify-center items-center">
        <Link to="/" onClick={handleScroll}>
          <div className="absolute left-0 right-0 bottom-0 top-0 bg-black opacity-20"></div>
        </Link>
        <div className="flex w-[1000px] h-[600px] relative z-10">
          <div className="relative w-[500px] overflow-hidden">
            <Swiper
              cssMode={true}
              navigation={true}
              pagination={true}
              mousewheel={true}
              keyboard={true}
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              className="mySwiper"
              onSlideChange={() => console.log("slide change")}
              onSwiper={(swiper) => console.log(swiper)}
            >
              <SwiperSlide>
                <img
                  src={`${process.env.PUBLIC_URL}/thumb${result}.jpg`}
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={`${process.env.PUBLIC_URL}/thumb${result}.jpg`}
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={`${process.env.PUBLIC_URL}/thumb${result}.jpg`}
                  alt=""
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src={`${process.env.PUBLIC_URL}/thumb${result}.jpg`}
                  alt=""
                />
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="w-[500px] h-full bg-white flex flex-col rounded-tr-md rounded-br-md">
            <div>
              <div className="flex items-center justify-between p-3 border-b border-gray-200 border-solid">
                <div className="flex items-center">
                  <img
                    src={`${process.env.PUBLIC_URL}/profile${result}.jpg`}
                    className="w-[32px] rounded-full"
                    alt=""
                  />
                  <p className="pl-3">{data[id].profile}</p>
                </div>
                <img src={`${process.env.PUBLIC_URL}/icon10.svg`} alt="" />
              </div>
              <div className="p-3 overflow-y-auto h-[382px] ">
                <div className="flex items-start mb-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/profile${result}.jpg`}
                    className="w-[32px] rounded-full"
                    alt=""
                  />
                  <div className="pl-3">
                    <p className="mb-3">{data[id].profile}</p>
                    <p className="mb-3 text-base">{data[id].content}</p>
                  </div>
                </div>
                <div className="flex items-start mb-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/who.jpg`}
                    className="w-[32px] rounded-full"
                    alt=""
                  />
                  <div className="pl-3">
                    <p className="mb-3">댓글 작성자</p>
                    <p className="mb-3 text-base">{data[0].content}</p>
                  </div>
                </div>
                <div className="flex items-start mb-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/who.jpg`}
                    className="w-[32px] rounded-full"
                    alt=""
                  />
                  <div className="pl-3">
                    <p className="mb-3">댓글 작성자</p>
                    <p className="mb-3 text-base">{data[0].content}</p>
                  </div>
                </div>
                <div className="flex items-start mb-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/who.jpg`}
                    className="w-[32px] rounded-full"
                    alt=""
                  />
                  <div className="pl-3">
                    <p className="mb-3">댓글 작성자</p>
                    <p className="mb-3 text-base">{data[0].content}</p>
                  </div>
                </div>
                <div className="flex items-start mb-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/who.jpg`}
                    className="w-[32px] rounded-full"
                    alt=""
                  />
                  <div className="pl-3">
                    <p className="mb-3">댓글 작성자</p>
                    <p className="mb-3 text-base">{data[0].content}</p>
                  </div>
                </div>
                <div className="flex items-start mb-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/who.jpg`}
                    className="w-[32px] rounded-full"
                    alt=""
                  />
                  <div className="pl-3">
                    <p className="mb-3">댓글 작성자</p>
                    <p className="mb-3 text-base">{data[0].content}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-auto ">
              <div className="p-3 border-t border-gray-200 border-solid">
                <div className="mb-3">
                  <button
                    onClick={like[id] === 0 ? handleLikeUp : handleLikeDown}
                    className={
                      likeimg[id] ? "hover:opacity-35" : "hover:opacity-100"
                    }
                  >
                    <img
                      onClick={() => {
                        let copy1 = [...like];
                        likeimg[id] ? copy1[id]++ : copy1[id]--;
                        setLike(copy1);
                        let copy2 = [...likeimg];
                        copy2[id] = !copy2[id];
                        setLikeimg(copy2);
                      }}
                      src={
                        likeimg[id]
                          ? `${process.env.PUBLIC_URL}/icon11.svg`
                          : `${process.env.PUBLIC_URL}/icon12.svg`
                      }
                      alt=""
                    />
                  </button>
                </div>
                <p className="mb-3">
                  좋아요 <span>{like[id]}</span>개
                </p>
                <p className=" text-xs text-gray-500">0월 0일</p>
              </div>
              <div className="p-3 border-t border-gray-200 border-solid">
                <input className="w-full  py-1" placeholder="댓글달기"></input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Detail;
